import { noop } from 'lodash'
import { createContext, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

export const NavigationConfirmationContext = createContext<$TSFIXME>(undefined)

export interface NavigationConfirmationProps {
  children: (...args: $TSFIXME[]) => $TSFIXME,
  functionAsChild: boolean,
}

export const NavigationConfirmation = ({ children = noop, functionAsChild = false }: NavigationConfirmationProps) => {
  const history = useHistory()
  const { callback, isActive } = useContext(NavigationConfirmationContext)
  useEffect(() => {
    // first param has no meaning except that blocking only works if the first param is a string or func that returns a string
    const unblock = history.block('')
    return () => unblock()
  }, [history])
  useEffect(() => {
    if (isActive && functionAsChild) {
      children(callback)
    }
  }, [isActive, functionAsChild, children])
  if (!functionAsChild && isActive) {
    return children(callback)
  }
  return null
}
